import { useEffect } from 'react';

import { Modals } from '@/helpers/modals';
import { REQUIRED_AUTH_FIELD } from '@/helpers/oauth';
import { useCommonStore, useModalsStore } from '@/store';

export const useTermsAndConditionsAcceptanceModal = () => {
  const open = useModalsStore.use.open();
  const user = useCommonStore.use.user();

  useEffect(() => {
    // if (!user?.authFieldsMissed?.includes(REQUIRED_AUTH_FIELD) || !user.country)
    //   return;
    if (!user?.authFieldsMissed?.includes(REQUIRED_AUTH_FIELD)) return;

    open(Modals.TermsAndConditionsAcceptance);
  }, [user, open]);
};
